
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import { DASHBOARD_ROOT } from "../../components/Routes/routingConstants";
import VideoLibraryTable from "../../components/ContentManagement/VideoLibraryTable";

export default function ContentVideoLibraryPage () {

    //#region Initialization
    const breadcrumbsData = [
        { name: 'Content List', path: `${DASHBOARD_ROOT}/content-management/` },
        { name: 'Video Library', path: `${DASHBOARD_ROOT}/content-management/library/videos` },
    ];

    //#endregion Initialization

    return (
        <>
            <Breadcrumbs 
                crumbs={breadcrumbsData}
            />

            <VideoLibraryTable limit={10} />

            
        </>
    )
    
}

